module.exports = {
          srcSet: __webpack_public_path__ + "images/1983-7d9e991e5573025c6410b0be705df72a-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1983-67b23421ce3ffe3cd866c774362d5c87-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1983-7d9e991e5573025c6410b0be705df72a-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1983-67b23421ce3ffe3cd866c774362d5c87-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1983-7d9e991e5573025c6410b0be705df72a-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1983-7d9e991e5573025c6410b0be705df72a-320.jpg"},
          
          width: 320,
          height: 251
        }